import * as Dialog from "@radix-ui/react-dialog";
import { AlertTriangle, Box, CheckCircle2, Info, Printer, Ruler, Triangle, X } from "lucide-react";
import { createPrintReport } from "../exporters/printAnalysis";
import { useModelStore } from "../state/store";

export function PrintPanel({ open, onOpenChange, onExport }: { open: boolean; onOpenChange: (open: boolean) => void; onExport: () => void }): React.JSX.Element {
  const evaluation = useModelStore((state) => state.evaluation);
  const report = createPrintReport(evaluation);

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="dialog-overlay" />
        <Dialog.Content className="dialog-content print-dialog">
          <div className="dialog-header"><div><Dialog.Title>Print readiness</Dialog.Title><Dialog.Description>Fast local checks before sending the model to a slicer.</Dialog.Description></div><Dialog.Close asChild><button className="icon-button"><X size={17} /></button></Dialog.Close></div>
          {!report ? <div className="report-empty"><Printer size={34} /><h3>No valid body to analyse</h3><p>Create or repair a solid first.</p></div> : (
            <>
              <div className="report-metrics">
                <Metric icon={<Ruler size={17} />} label="Dimensions" value={`${report.dimensions.map((value) => value.toFixed(1)).join(" × ")} mm`} />
                <Metric icon={<Box size={17} />} label="Volume" value={`${report.volume.toFixed(1)} mm³`} />
                <Metric icon={<Triangle size={17} />} label="Triangles" value={report.triangles.toLocaleString()} />
                <Metric icon={<Printer size={17} />} label="Bodies" value={String(report.bodyCount)} />
              </div>
              <div className="issue-list">
                {report.issues.map((issue, index) => (
                  <div className={`issue-card ${issue.severity}`} key={`${issue.title}-${index}`}>
                    {issue.severity === "error" ? <AlertTriangle size={18} /> : issue.severity === "warning" ? <AlertTriangle size={18} /> : issue.title === "Ready to slice" ? <CheckCircle2 size={18} /> : <Info size={18} />}
                    <div><strong>{issue.title}</strong><p>{issue.detail}</p></div>
                  </div>
                ))}
              </div>
              <p className="report-disclaimer">These checks are heuristics, not a guarantee of printability. Inspect the sliced preview before printing.</p>
            </>
          )}
          <div className="dialog-footer"><button className="button ghost" onClick={() => onOpenChange(false)}>Close</button><button className="button primary" disabled={!report} onClick={() => { onOpenChange(false); onExport(); }}><Printer size={16} /> Export for printing</button></div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

function Metric({ icon, label, value }: { icon: React.JSX.Element; label: string; value: string }): React.JSX.Element {
  return <div className="report-metric"><span>{icon}</span><div><small>{label}</small><strong>{value}</strong></div></div>;
}
